/* Map thumbnail with the old fallback chain: GitHub .png → .jpg → placeholder
 * (workshop maps → /ws-map-not-found.png, stock maps → /cs2-map-not-found.png). */
import React from 'react';

export const githubImage = (name) => `https://raw.githubusercontent.com/rpkaul/cs-map-images/refs/heads/main/${name}.png`;

export default function MapImage({ src, workshop, alt = '', className }) {
  const fallback = workshop ? '/ws-map-not-found.png' : '/cs2-map-not-found.png';
  return (
    <img
      className={className}
      src={src || fallback}
      alt={alt}
      loading="lazy"
      onError={(e) => {
        const cur = e.target.src;
        if (cur.endsWith('.png') && !cur.endsWith('-not-found.png')) e.target.src = cur.replace(/\.png$/, '.jpg');
        else if (cur.endsWith('.jpg')) e.target.src = fallback;
        else { e.target.onerror = null; if (!cur.endsWith('-not-found.png')) e.target.src = fallback; }
      }}
    />
  );
}

/** "de_dust2" → "Dust2", "aim_redline_v2" → "Aim Redline V2" (display only; the real name stays visible too). */
export function prettyMapName(name) {
  const s = String(name || '').replace(/^(de|cs|ar|dz|gd)_/i, '').replace(/_/g, ' ');
  return s.replace(/\b\w/g, c => c.toUpperCase());
}
